<div class="container-fluid d-flex justify-content-center caja-interior white-background">
	
        <div class="align-self-md-center pt-3">
    
    
            <div class="card shadow animated fadeInUp">
                <h1>algo algo</h1>                
                <div class="card-body">
                        
                        <form name="registerForm" (ngSubmit)="processForm()">
                            
                            <div [formGroup]="registerForm">
                                <mat-form-field appearance="outline" class="d-block">
                                    <mat-label>Nombre</mat-label>
                                    <input matInput formControlName="displayName">
                                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                    <mat-error>
                                        El nombre es nesesario
                                    </mat-error>
                                </mat-form-field>
    
                                <mat-form-field appearance="outline" class="d-block">
                                    <mat-label>E-mail</mat-label>
                                    <input matInput formControlName="email">
                                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                                    <mat-error *ngIf="registerForm.get('email').hasError('required')">
                                        Email es nesesario
                                    </mat-error>
                                    <mat-error *ngIf="registerForm.get('email').hasError('email')">
                                        Ingrese un correo valido
                                    </mat-error>
                                </mat-form-field>
    
                                <mat-form-field appearance="outline" class="d-block">
                                    <mat-label>Contraseña</mat-label>
                                    <input matInput type="password" formControlName="password">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error>
                                        La contraseña es nesesaria
                                    </mat-error>
                                </mat-form-field>
    
                                <mat-form-field appearance="outline" class="d-block">
                                    <mat-label>Contraseña (Confirmación)</mat-label>
                                    <input matInput type="password" formControlName="passwordConfirm">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error *ngIf="registerForm.get('passwordConfirm').hasError('required')">
                                        La confirmación de la contraseña es necesaria
                                    </mat-error>
                                    <mat-error *ngIf="!registerForm.get('passwordConfirm').hasError('required') &&
                                                    registerForm.get('passwordConfirm').hasError('passwordsNotMatching')">
                                        Las contraseñas deben coincidir.
                                    </mat-error>
                                </mat-form-field>
    
                                <div class="p">
                                    <mat-checkbox name="terms" aria-label="I read and accept" formControlName="leidoAceptado">
                                        <span>
                                            Acepto <a href="/inicio">terminos y condiciones.</a>
                                        </span>
                                    </mat-checkbox>
                                </div>
    
                                <p class="d-block text-center pt-2 pb-2">
                                    <button color="accent" mat-raised-button color="accent" class="d-block w-100" [disabled]="registerForm.invalid">
                                        <mat-icon matSuffix>send</mat-icon> 
                                        CREAR MI CUENTA
                                    </button>
                                </p>
                            </div>
                

                        </form>

                        
                        <!-- <form name="loginForm" [formGroup]="loginForm" novalidate>

                            <mat-form-field appearance="outline" class="d-block">
                                <mat-label>Correo electrónico</mat-label>
                                <input matInput formControlName="email">
                                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                                    <mat-error *ngIf="loginForm.get('email').hasError('required')">
                                        El correo es requerido
                                    </mat-error>
                                    <mat-error
                                        *ngIf="!loginForm.get('email').hasError('required') &&
                                                loginForm.get('email').hasError('email')">
                                        Por favor ingrese un correo valido
                                    </mat-error>
                            </mat-form-field>
            
                            <mat-form-field appearance="outline" class="d-block">
                                <mat-label>Contraseña</mat-label>
                                <input matInput type="password" formControlName="password">
                                <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                <mat-error>
                                    La contraseña es un campo requerido
                                </mat-error>
                            </mat-form-field>

                            <div class="d-block">
                                    <button mat-raised-button color="accent" class="d-block" aria-label="LOG IN"
                                            [disabled]="loginForm.invalid" 
                                            (click)="iniciarSesion()" style="width: 100%">
                                        INICIAR SESIÓN
                                    </button>
                            </div>
            
                            
                            <hr>
                
                            

                            <div class="row d-block">
                                <p class="text-center text-secondary">
                                    ¿No tienes cuenta aún?
                                </p>

                                <p class="text-center">
                                    <button mat-raised-button [routerLink]="'/usuario-registrar'">
                                        CREA UNA CUENTA
                                    </button>
                                </p>
                            </div>

                            <div class="row d-block">
                                <div class="col mt-3">
                                    <p class="text-center text-danger">
                                        <a class="" [routerLink]="'/pages/auth/forgot-password'">
                                            ¿Olvidaste tu contraseña?
                                        </a>
                                    </p>
                                </div>
                            </div>

            
                        </form> -->
                    
                </div>
            </div>

        </div>
</div>